<template>
  <div class="page-single">
    <div class="container">
      <div class="row">
        <div class="col col-login mx-auto">
          <div class="text-center mb-6">
            <img src="../../assets/Goalpilot_logo_white_500.png" class="h-6" alt="">
          </div>
          <form class="card" @submit.prevent="onSubmit">
            <div class="card-body p-6">
              <div class="card-title">Forgot password</div>
              <p class="text-muted">Enter your email address and your password will be reset and emailed to you.</p>
              <div class="form-group">
                <label class="form-label" for="exampleInputEmail1">Email address</label>
                <input v-model="userInput.userEmail" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
              </div>
              <div class="form-footer">
                <button type="submit" class="btn btn-primary btn-block">Send me new password</button>
              </div>
            </div>
          </form>
          <div class="text-center text-muted">
            Forget it, <a href="#" @click.prevent="onGoBack">send me back</a> to the sign in screen.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: Captcha

export default {
  data() {
    return {
      userInput: {
        userEmail: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.$api.auth_forgot_password(this.userInput).then(() => {
        this.$message({
          message: 'Email with reset link was sent to' + this.userInput.userEmail + '.',
          type: 'success'
        });
      }).catch(error => {
        this.$message.error({
          message: 'Resetting password faild with error: ' + error,
          type: 'error'
        });
      });
      this.$emit("user-forgot-password", this.userInput)
    },
    onGoBack() {
      this.$router.go(-1)
    },
  }
}
</script>
